import { render, staticRenderFns } from "./form_answer_score.vue?vue&type=template&id=0970e374&scoped=true"
import script from "./form_answer_score.vue?vue&type=script&lang=js"
export * from "./form_answer_score.vue?vue&type=script&lang=js"
import style0 from "./form_answer_score.vue?vue&type=style&index=0&id=0970e374&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0970e374",
  null
  
)

export default component.exports